import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { TradeTypeEnum } from "@/types/FmsEnums";
import { IBillDetail } from "@/views/bill/BillTypes";
import { useStatisticPurchaseModel } from "./statisticPurchaseModel";
import useNavModel from '@/model/navModel';
import BillDetailRender from "@/views/vrmBill";


export function BillDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, payMethodLabels
    } = useStatisticPurchaseModel();

    const columns: ColumnsType<IBillDetail> = [
        {
            align: "center",
            width: 60,
            ellipsis: true,
            title: '序号',
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            width: 200,
            title: '单据编号',
            dataIndex: 'tradeCode',
            render: (t, r) => BillDetailRender(t, r),
        },
        {
            align: "center",
            width: 200,
            title: '单据类型',
            dataIndex: 'tradeTypeName',
        }, {
            align: "center",
            width: 260,
            ellipsis: true,
            title: '供应商名称',
            dataIndex: 'partnerName',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '单据金额',
            dataIndex: 'billAmount',
            // render: (text, record) => (
            //     record.tradeTypeCode === TradeTypeEnum.SALE_RETURN ||
            //     record.tradeTypeCode === TradeTypeEnum.PURCHASE_RETURN ||
            //     record.tradeTypeCode === TradeTypeEnum.BILL_FAVORABLE) ? Math.abs(text) : text
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '支付类型',
            dataIndex: 'payType',
            render: v => payMethodLabels[v] ?? '暂无'
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '备注',
            dataIndex: 'note',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '账户类型',
            dataIndex: 'accountTypeName',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '分支',
            dataIndex: 'branch',
        },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: '账单编码',
            dataIndex: 'code',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '单据类型',
            dataIndex: 'tradeTypeName',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '优惠类型',
            dataIndex: 'preferentialTypeName',
            render: v => v ?? '暂无'
        },
        {
            align: "center",
            width: 300,
            ellipsis: true,
            title: '记账账户',
            dataIndex: 'accountCode',
        },
        {
            align: "center",
            width: 300,
            ellipsis: true,
            title: '账户名',
            dataIndex: 'accountName',
        },
        {
            align: "center",
            width: 300,
            ellipsis: true,
            title: '销售实体',
            dataIndex: 'beName',
        },
        {
            align: "center",
            width: 300,
            ellipsis: true,
            title: '门店',
            dataIndex: 'shopName',
        },
        // {
        //     align: "center",
        // width: 100,
        // ellipsis: true,
        //     title: '从属机构',
        //     dataIndex: 'orgName',
        // },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '记账日期',
            dataIndex: 'createTime',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '业务员',
            dataIndex: 'tradeOperator',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '核销日期',
            dataIndex: 'writeoffTime',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '核销人',
            dataIndex: 'writeoffUser',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '账单状态',
            dataIndex: 'status',
            render: (v) => v === 0 ? "初始" : v === 1 ? '已记账' : v === 2 ? '已核销' : ""
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '取消状态',
            dataIndex: 'cancelStatus',
            render: (v) => v === 0 ? '初始' : v === 1 ? '审核中' : v === 2 ? '已取消' : v === 9 ? '异常 ' : ''
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '收支类型',
            dataIndex: 'ioFlag',
            render: (v) => v === 1 ? '收' : v === 2 ? '支' : ''
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '已开票金额',
            dataIndex: 'invoiceAmount',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '开票状态',
            dataIndex: 'invoiceStatus',
            render: (v) => v === 0 ? "初始" : v === 1 ? '申请中' : v === 2 ? '部分开票' : v === 3 ? '已开票' : ""
        },

    ];

    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IBillDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
            scroll={{ x: "max-content", y: "calc(100vh - 420px)" }}
        />
    )
}
